import { render, staticRenderFns } from "./RentalEmploymentMessages.vue?vue&type=template&id=610108e0&scoped=true&"
import script from "./RentalEmploymentMessages.vue?vue&type=script&lang=js&"
export * from "./RentalEmploymentMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610108e0",
  null
  
)

export default component.exports